/* Build Your Set - persistent buy bar.
   Audit finding: the set rail's Add-to-cart was reachable for only 19% of page
   depth (scrollY 0-1200 of 5783); the benchmark competitor holds 75%. This bar
   recovers the rest.

   It OWNS NO CART LOGIC. It mirrors whichever rail is relevant and forwards its
   click to that rail's real button, so pricing, disabled state, ladder maths and
   the add flow all stay in exactly one place.

   Namespace is data-bb-*, never data-bys-* or data-gp-*: build-your-set.js paints
   every [data-bys-*] on the page and would otherwise overwrite this bar.

   Two responsive modes:
     desktop >=1100  bar appears once the relevant rail scrolls off, identity
                     follows the segment in view (set or gown).
     mobile  <1100   the theme's own .bys__bar already covers the set. This bar
                     only takes over inside the nightgown segment, and hides
                     .bys__bar while it does, so there is never more than one. */
(function () {
  var MOBILE_MAX = 1099;

  function boot() {
    var root = document.querySelector('[data-bys-root]');
    if (!root || root.getAttribute('data-bb-ready') === '1') return;

    var setRail = root.querySelector('.bys__rail');
    var setAdd = root.querySelector('[data-bys-add]');
    if (!setRail || !setAdd) return;

    /* DayBasics only. The nightgown band is what makes that page long enough to
       lose its rail, and it is the only page the audit measured; NightCool keeps
       the layout it has today until Sandra asks for this there. */
    var gownSeg = document.querySelector('[data-bys-gownpick]');
    if (!gownSeg) return;

    root.setAttribute('data-bb-ready', '1');

    var themeBar = root.querySelector('[data-bys-sticky]');
    var gownRail = gownSeg ? gownSeg.querySelector('.bys__grail') : null;
    var gownAdd = gownSeg ? gownSeg.querySelector('[data-gp-add]') : null;

    var bar = document.createElement('div');
    bar.className = 'bys__buybar';
    bar.setAttribute('data-bb-root', '');
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="bys__buybar-in">' +
        '<div class="bys__buybar-thumbs" data-bb-thumbs aria-hidden="true"></div>' +
        '<div class="bys__buybar-t">' +
          '<b data-bb-title></b>' +
          '<span data-bb-price></span>' +
        '</div>' +
        '<button class="bys__buybar-cta" type="button" data-bb-add></button>' +
      '</div>';
    root.appendChild(bar);

    var thumbsEl = bar.querySelector('[data-bb-thumbs]');
    var titleEl = bar.querySelector('[data-bb-title]');
    var priceEl = bar.querySelector('[data-bb-price]');
    var ctaEl = bar.querySelector('[data-bb-add]');

    /* which segment the shopper is looking at, and whether its rail is on screen */
    var inGown = false, setRailSeen = true, gownRailSeen = false;
    var mode = 'set';

    function isMobile() { return window.innerWidth <= MOBILE_MAX; }

    /* Read visibility from live geometry rather than trusting a cached observer
       flag. Sticky rails move under the shopper, so the rect is the only honest
       answer, and it is the same answer in renderers that never fire IO. */
    function onScreen(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < (window.innerHeight || 0);
    }
    /* A third of the segment on screen counts as the shopper's focus: the same
       band the -33% rootMargin described. */
    function inFocus(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      var h = window.innerHeight || 0;
      return r.bottom > h * 0.33 && r.top < h * 0.67;
    }

    function thumbHTML(src, alt) {
      if (!src) return '';
      return '<img src="' + src + '" alt="' + (alt || '').replace(/"/g, '&quot;') +
             '" width="44" height="44" loading="lazy">';
    }

    /* Mirror the set rail: slot thumbs, both style names, strike + pay price. */
    function readSet() {
      var slots = setRail.querySelectorAll('.bys__slot.is-filled');
      var names = [], thumbs = '';
      [].slice.call(slots).forEach(function (s) {
        var b = s.querySelector('.bys__slot-t b');
        var img = s.querySelector('.bys__slot-thumb img');
        if (b) names.push(b.textContent.trim());
        if (img) thumbs += thumbHTML(img.getAttribute('src'), b ? b.textContent.trim() : '');
      });
      var full = setRail.querySelector('[data-bys-fullprice]');
      var pay = setRail.querySelector('[data-bys-payprice]');
      return {
        thumbs: thumbs,
        title: names.length === 2 ? 'Your set: ' + names.join(' + ')
             : names.length === 1 ? names[0] + ' picked'
             : 'Your DayBasics set',
        strike: (full && !full.hidden) ? full.textContent.trim() : '',
        pay: pay ? pay.textContent.trim() : '',
        label: setAdd.textContent.trim(),
        disabled: !!setAdd.disabled
      };
    }

    /* Mirror the gown rail. Its "Your pick" slot is the one being added. */
    function readGown() {
      if (!gownRail) return null;
      var pick = gownRail.querySelector('.bys__gtag--pick');
      var slot = pick ? pick.closest('.bys__slot') : null;
      var b = slot ? slot.querySelector('.bys__slot-t b') : null;
      var img = slot ? slot.querySelector('.bys__slot-thumb img') : null;
      var full = gownRail.querySelector('[data-gp-fullprice]');
      var pay = gownRail.querySelector('[data-gp-payprice]');
      var inCart = gownRail.querySelectorAll('.bys__gtag:not(.bys__gtag--pick)').length;
      return {
        thumbs: img ? thumbHTML(img.getAttribute('src'), b ? b.textContent.trim() : '') : '',
        title: b ? b.textContent.trim()
             : (inCart ? inCart + (inCart === 1 ? ' gown in your cart' : ' gowns in your cart')
                       : 'Your nightgowns'),
        strike: (full && !full.hidden) ? full.textContent.trim() : '',
        pay: pay ? pay.textContent.trim() : '',
        label: gownAdd ? gownAdd.textContent.trim() : '',
        disabled: gownAdd ? !!gownAdd.disabled : true
      };
    }

    function paint() {
      var d = (mode === 'gown') ? readGown() : readSet();
      if (!d) return;
      if (thumbsEl.innerHTML !== d.thumbs) thumbsEl.innerHTML = d.thumbs;
      titleEl.textContent = d.title;
      priceEl.innerHTML = (d.strike ? '<s>' + d.strike + '</s>' : '') +
                          '<em>' + d.pay + '</em>';
      ctaEl.textContent = d.label;
      ctaEl.disabled = d.disabled;
      bar.classList.toggle('is-gown', mode === 'gown');
    }

    /* Decide which bar, if any, should be on screen. */
    function sync() {
      inGown = inFocus(gownSeg);
      setRailSeen = onScreen(setRail);
      gownRailSeen = onScreen(gownRail);

      var wantGown = inGown && !!gownRail;
      mode = wantGown ? 'gown' : 'set';

      var show;
      if (isMobile()) {
        /* The theme bar already covers the set on mobile, so this bar exists
           only to take the gown segment off its hands. */
        show = wantGown;
        if (themeBar) themeBar.classList.toggle('is-bb-yielded', wantGown);
      } else {
        if (themeBar) themeBar.classList.remove('is-bb-yielded');
        show = wantGown ? !gownRailSeen : !setRailSeen;
      }

      if (show) paint();
      bar.classList.toggle('is-up', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    /* Scroll is the primary trigger, rAF throttled so it costs one rect read a
       frame. IntersectionObserver is kept as a second trigger for layout shifts
       that move a rail without a scroll, but nothing depends on it firing:
       its callbacks need the compositor to produce frames, and some embedded
       renderers never do, which would leave the bar silently stuck down. */
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; sync(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function () { sync(); }, { threshold: 0 });
      io.observe(setRail);
      if (gownRail) io.observe(gownRail);
      if (gownSeg) io.observe(gownSeg);
    }

    /* The rails repaint themselves on pick, on cart poll and on add. Mirror
       whatever they land on rather than recomputing any of it here. */
    var mo = new MutationObserver(function () { if (bar.classList.contains('is-up')) paint(); });
    mo.observe(setRail, { subtree: true, childList: true, characterData: true, attributes: true,
                          attributeFilter: ['hidden', 'disabled', 'class'] });
    if (gownRail) {
      mo.observe(gownRail, { subtree: true, childList: true, characterData: true, attributes: true,
                             attributeFilter: ['hidden', 'disabled', 'class'] });
    }

    ctaEl.addEventListener('click', function () {
      var real = (mode === 'gown') ? gownAdd : setAdd;
      if (real && !real.disabled) real.click();
    });

    window.addEventListener('resize', sync);
    document.addEventListener('cart:updated', function () { setTimeout(paint, 60); });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();


/* ---------------------------------------------------------------------------
   CJ TAB DEEP LINK.  Appended to buybar because buybar is the last script the
   section loads, and it loads on both builder pages unconditionally, so this
   needs no change to sections/cj-build-your-set.liquid.

   /pages/build-your-set?tab=men opens the Men's tab instead of the first one.

   Why it exists: the Women's and Men's nav links point at the SAME page URL, so
   without a parameter every visitor lands on whichever group block is first.

   Accepts ?tab=... or #hash. Understands men/mens/male/his/guys,
   women/womens/ladies/female/hers, or a literal block id such as grp_men.

   CAREFUL: "women" CONTAINS "men", so a naive substring match sends men's
   traffic to the women's tab. Women is tested FIRST and excluded.

   Clicks the real tab button rather than reimplementing the switch, so the
   builder's own handler stays the single owner of panel visibility. Retries for
   ~2s because the button only responds once those handlers are bound.
   --------------------------------------------------------------------------- */
(function () {
  function norm(s) { return (s || '').toString().toLowerCase().trim(); }

  function wanted() {
    var q = '';
    try { q = new URLSearchParams(window.location.search).get('tab') || ''; } catch (e) {}
    if (!q && window.location.hash) { q = window.location.hash.replace(/^#/, ''); }
    return norm(q);
  }

  function groupOf(btn) {
    var hay = norm(btn.getAttribute('data-bys-tab') + ' ' + (btn.textContent || ''));
    if (hay.indexOf('women') > -1 || hay.indexOf('ladies') > -1) { return 'women'; }
    if (hay.indexOf('men') > -1) { return 'men'; }
    return '';
  }

  function resolve(tabs, want) {
    var i;
    for (i = 0; i < tabs.length; i++) {
      if (norm(tabs[i].getAttribute('data-bys-tab')) === want) { return tabs[i]; }
    }
    var target = '';
    if (/^(men|mens|man|male|his|guys)$/.test(want)) { target = 'men'; }
    else if (/^(women|womens|woman|ladies|female|hers)$/.test(want)) { target = 'women'; }
    if (!target) { return null; }
    for (i = 0; i < tabs.length; i++) {
      if (groupOf(tabs[i]) === target) { return tabs[i]; }
    }
    return null;
  }

  function attempt() {
    var want = wanted();
    if (!want) { return true; }
    var root = document.querySelector('[data-bys-root]');
    if (!root) { return false; }
    var tabs = [].slice.call(root.querySelectorAll('[data-bys-tab]'));
    if (tabs.length < 2) { return true; }
    var hit = resolve(tabs, want);
    if (!hit) { return true; }
    if (hit.getAttribute('aria-pressed') === 'true') { return true; }
    hit.click();
    return hit.getAttribute('aria-pressed') === 'true';
  }

  function boot() {
    if (attempt()) { return; }
    var tries = 0;
    var timer = setInterval(function () {
      if (attempt() || ++tries > 20) { clearInterval(timer); }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
